import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

const CONTEXT = 'dashboard';

export const fetchCumulativeWinners = (retailerId) => {
  const { url } = DepsService.rest.widgets.cummulativeWinners;
  const queryParams = {};
  const urlParams = { retailerId };
  const path = 'widgets.cummulativeWinners';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};

export const fetchCumulativeWinnersHistory = (queryParams, retailerId) => {
  const { url } = DepsService.rest.widgets.cumulativeHistory;
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const downloadCumulativeWinnersHistoryReport = (queryParams, retailerId, extension) => {
  const { url } = DepsService.rest.widgets.cumulativeHistory;
  const urlParams = { retailerId };
  const headers = appHelpers.setHeader(extension);

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/cumulative-winners.api.js